import React, { Component } from 'react';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { mergeStyles } from 'wix-rich-content-common';
import { I as InfoIcon } from '../InfoIcon-8711d7eb.js';
import Toggle from './Toggle.js';
import 'wix-rich-content-common/libs/Tooltip';
import '../Icons/InfoIcon.js';
import 'classnames';

var css_248z = ".uQ3xx{display:flex}[dir] .uQ3xx * p{margin:0}.uQ3xx{gap:36px}[dir] .uQ3xx{padding-top:24px}@media only screen and (max-width:640px){[dir] [data-query=media] .uQ3xx+.uQ3xx{padding-top:36px}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] [data-query=container] .uQ3xx+.uQ3xx{padding-top:36px}}}@container (width < 640px){[dir] [data-query=container] .uQ3xx+.uQ3xx{padding-top:36px}}.jZO7i{height:100%;width:100%}[dir] .jZO7i{margin:0}.jut1n{fill:var(--ricos-settings-icons-color,#000);color:var(--ricos-settings-icons-color,#000)}[dir] .jut1n{cursor:pointer}[dir=ltr] .jut1n{margin-left:4px}[dir=rtl] .jut1n{margin-right:4px}.NdTe6{align-items:center;display:flex;flex-direction:row;justify-content:center}.-d9qD{color:var(--ricos-settings-text-color,#000);font-size:16px}[dir=ltr] .-d9qD{text-align:left}[dir=rtl] .-d9qD{text-align:right}@media only screen and (max-width:640px){[data-query=media] .-d9qD{font-size:14px}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[data-query=container] .-d9qD{font-size:14px}}}@container (width < 640px){[data-query=container] .-d9qD{font-size:14px}}";
var styles = {"labeled_toggle_root":"uQ3xx","labeled_toggle_checkbox_input":"jZO7i","infoIcon":"jut1n","labeled_toggle_label_wrapper":"NdTe6","labeled_toggle_label":"-d9qD"};
styleInject(css_248z);

class LabeledToggle extends Component {
  constructor(props) {
    super(props);
    this.styles = mergeStyles({ styles, theme: props.theme });
  }
  render() {
    const { label, onChange, checked, style, dataHook, tooltipText, isMobile = false } = this.props;
    return /* @__PURE__ */ React.createElement("div", { className: this.styles.labeled_toggle_root, style }, /* @__PURE__ */ React.createElement("div", { className: this.styles.labeled_toggle_label_wrapper }, /* @__PURE__ */ React.createElement(
      "div",
      {
        role: "button",
        tabIndex: 0,
        onClick: onChange,
        onKeyPress: (e) => e.key === "Enter" && onChange()
      },
      /* @__PURE__ */ React.createElement("p", { className: this.styles.labeled_toggle_label }, label)
    ), tooltipText && !isMobile && /* @__PURE__ */ React.createElement(InfoIcon, { iconStyles: styles.infoIcon, tooltipText })), /* @__PURE__ */ React.createElement(Toggle, { checked, onChange, dataHook }));
  }
}

export { LabeledToggle as default };
//# sourceMappingURL=LabeledToggle.js.map
